import React from 'react'
import TaskTypeIcon from "../../../../icons/task-icon/task-icon-ui5"
import UserIcon from "../../../../icons/user/user"
import {ItemIconDict} from "../../../../../gd/const/item-icon/icon/icons";

type Props = {
    mention     : any
}

export default function MentionComponent(props: Props): JSX.Element {
    let res = <span/>

    switch (props.mention.type) {
        case gd.const.editorLink.type.TASK  :
            const task = props.mention.data
            res = (
                <div className="mention-item">
                    <TaskTypeIcon className="mention-icon m-r-5" icon={task.icon}/>
                    <div className="ui5-txt-default-small max-w-200 txt-truncate">{task.title}</div>
                </div>
            )
            break

        case gd.const.editorLink.type.NOTE  :
            const note = props.mention.data
            res = (
                <div className="mention-item">
                    <div className={Classes("mention-icon ui5-ico-13 m-r-5", ItemIconDict[note.noteType.icon].className)}/>
                    <div className="ui5-txt-default-small max-w-200 txt-truncate">{note.name}</div>
                </div>
            )
            break

        case gd.const.editorLink.type.USER  :
            res = (
                <div className="mention-item user-mention">
                    <UserIcon className="m-r-5" userId={props.mention.id} hint={false} size="22"/>
                    <div className="ui5-txt-default-small max-w-200 txt-truncate">{props.mention.name}</div>
                </div>
            )
            break

        /*case gd.const.editorLink.type.PROJECT:
            res = (
                <div className="mention-item">
                    <ProjectIconUI5 className="mention-icon m-r-5" size="13" projectId={props.mention.id} colorize={false}/>
                    <div className="ui5-txt-default-small max-w-200 txt-truncate">{props.mention.name}</div>
                </div>
            )
            break*/
    }

    return res
}
